import React, {Fragment} from 'react';
import CtxContent from './CtxContent';

function Translation({name}) {
	return (
		<CtxContent.Consumer>
			{content => {
				if (!content || !content.translations || !content.translations[name]) {
					return (
						<span
							className="slx-mounting-translation slx-mounting-translation--missing"
						>
							unknown translation `{name}`
						</span>
					);
				}
				return content.translations[name];
			}}
		</CtxContent.Consumer>
	);
}

export default React.memo(Translation);
